<script>
  import { createEventDispatcher } from "svelte";

  export let item;
  export let currency = "";
  export let legendPlaceholder = "Description";
  export let pricePlaceholder = "Price";
  export let addLineLabel = "Add price line";
  export let removeLineLabel = "Remove price line";

  const dispatch = createEventDispatcher();
  const newLine = (legend = "", price = "") => ({ legend, price });
  const initialPrice = item.val !== undefined && item.val !== null ? String(item.val) : "";

  item.priceLines = Array.isArray(item.priceLines) && item.priceLines.length
    ? item.priceLines.map((line) => newLine(line?.legend ?? line?.label ?? "", line?.price ?? ""))
    : [newLine("", initialPrice)];

  if (item.priceLines.some((line) => line.price !== "" && line.price !== null && line.price !== undefined)) {
    const initialTotal = item.priceLines.reduce(
      (sum, line) => sum + (parseFloat(String(line.price ?? "").replace(",", ".")) || 0),
      0
    );
    item.val = String(Math.round((initialTotal + Number.EPSILON) * 100) / 100);
  }

  function syncValue() {
    const hasPrice = item.priceLines.some((line) => line.price !== "" && line.price !== null && line.price !== undefined);
    const total = item.priceLines.reduce((sum, line) => sum + (parseFloat(String(line.price ?? "").replace(",", ".")) || 0), 0);
    item.val = hasPrice ? String(Math.round((total + Number.EPSILON) * 100) / 100) : "";
    item.priceLines = [...item.priceLines];
    dispatch("change");
  }

  function addLine() {
    item.priceLines = [...item.priceLines, newLine()];
    dispatch("change");
  }

  function removeLine(index) {
    item.priceLines = item.priceLines.length === 1 ? [newLine()] : item.priceLines.filter((_, i) => i !== index);
    syncValue();
  }
</script>

<div id={item.id} class="cw-price-lines" class:error-border={item.isError}>
  {#each item.priceLines as line, lineIndex}
    <div class="cw-price-line">
      <input type="text" bind:value={line.legend} placeholder={legendPlaceholder} aria-label={`${item.label || pricePlaceholder}: ${legendPlaceholder}`} on:input={syncValue} on:focus={() => dispatch("focus")} />
      <div class="cw-price-value">
        <input type="number" min={item.min} max={item.max} step="any" bind:value={line.price} placeholder={pricePlaceholder} aria-label={`${item.label || pricePlaceholder}: ${pricePlaceholder}`} on:input={syncValue} on:focus={() => dispatch("focus")} />
        {#if currency}<span>{currency}</span>{/if}
      </div>
      {#if lineIndex === item.priceLines.length - 1}
        <button type="button" class="cw-price-line-action cw-price-line-add" aria-label={addLineLabel} on:click={addLine}>+</button>
      {:else}
        <span></span>
      {/if}
      <button type="button" class="cw-price-line-action cw-price-line-remove" aria-label={removeLineLabel} on:click={() => removeLine(lineIndex)}>×</button>
    </div>
  {/each}
  <input type="hidden" value={item.val} />
</div>
